import {extendObservable, action, computed} from "mobx";
import {CHAT_STATE, CHAT_DEFAULT_SUBJECT} from '../constants';
import {BELL_SOUND, CLICK_SOUND} from '../sound/sounds';


export default class Ui {

    constructor(rootStore, viewState){
        this.rootStore = rootStore;
        extendObservable(this, {
            viewState: CHAT_STATE.MINIMIZED,
        });

        this.lastViewState = viewState;
        this.lastMaximizedState = CHAT_STATE.CONVERSATIONS_LIST;
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // MINIMIZATION/MAXIMIZATION
    @action
    toggleShow(){
        if( this.minimized ){
            this.maximize();
        }
        else{
            this.minimize();
        }
    }

    @computed
    get minimized(){
        return this.viewState == CHAT_STATE.MINIMIZED;
    }

    @computed 
    get isConversation(){
        return this.viewState == CHAT_STATE.CONVERSATION;
    }

    @action
    maximize(){
        this.viewState = this.lastMaximizedState;
        this.rootStore.conversationsStore.fetchIndex();
    }

    @action
    minimize(){
        if( !this.minimized ){
            this.lastMaximizedState = this.viewState;
            this.viewState = CHAT_STATE.MINIMIZED;
        }
    }
    // end MINIMIZATION/MAXIMIZATION
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // MENU BAR
    @computed
    get showMenuBar(){
        const statesWhereShouldRender = [
            CHAT_STATE.CONVERSATIONS_LIST,
            CHAT_STATE.CONVERSATION,
            CHAT_STATE.LOADING
        ];
        return statesWhereShouldRender.includes(this.viewState);
    }

    @computed
    get showBackBtn(){
        let statesWhereShouldNotShow = [
            CHAT_STATE.CONVERSATIONS_LIST
        ];
        return !statesWhereShouldNotShow.includes(this.viewState);
    }

    @computed
    get menuBarTitle(){
        let title ="";
        const intl = this.rootStore.localeStore.intl;
        switch(this.viewState){
            case CHAT_STATE.CONVERSATIONS_LIST:
                title = intl.formatMessage({id: "conversations_list_title"})
                break;
            case CHAT_STATE.CONVERSATION:
                title = this.rootStore.conversationsStore.currentConversation.name;
                break;
            case CHAT_STATE.LOADING:
                title = intl.formatMessage({id: "loading_title"});
                break;
        }
        return title;
    }

    handleClickBack(){
        switch( this.viewState ){
            case CHAT_STATE.LOADING:
                this.showConversationsList();
                break;
            case CHAT_STATE.CONVERSATION:
                this.showConversationsList();
                break;
            case CHAT_STATE.NEW_GROUP_FORM:
                this.showNewConversationForm();
                break;
            case CHAT_STATE.NEW_CONVERSATION_FORM:
            default:
                this.showConversationsList();
        }
    }
    // end MENU BAR
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    @action
    showConversationsList(){
        if( this.rootStore.conversationsStore.conversations.length == 0 ){
            this.showNewConversationForm();
        }
        else{
            this.viewState = CHAT_STATE.CONVERSATIONS_LIST;
        }
    }

    @action
    showNewConversationForm(){
        this.viewState = CHAT_STATE.NEW_CONVERSATION_FORM;
    }

    @action
    showLoading(){
        this.viewState = CHAT_STATE.LOADING;
    }

    @action
    showConversation(){
        this.viewState = CHAT_STATE.CONVERSATION;
    }

    @action 
    handleNewGroupClick(){
        this.showNewGroupForm();
    }

    @action
    showNewGroupForm(){
        this.viewState = CHAT_STATE.NEW_GROUP_FORM;
    }

    @action 
    handleNewConversationBtnClick(){
        this.showNewConversationForm();
    }

    @action 
    handleNewReply(){
        this.playNewMessageSound();
    }


    @action 
    recoverLastChatState(){
        switch(this.lastViewState){
            case CHAT_STATE.CONVERSATION:
                this.rootStore.conversationsStore.initialConversation.openConversation();
                break;
            case CHAT_STATE.CONVERSATIONS_LIST:
                this.showConversationsList();
                break;
            default:
                break;
        }
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // SOUNDS
    @action
    playNewMessageSound(){
        if( this.viewState == CHAT_STATE.CONVERSATION ){
            CLICK_SOUND.load();
            CLICK_SOUND.play();
        }
        else{
            BELL_SOUND.load();
            BELL_SOUND.play();
        }
    }

    playNewConversationSound(){
        BELL_SOUND.load();
        BELL_SOUND.play();
    }
    // end SOUNDS
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



}